<div class="flex flex-col flex-auto min-w-0">
    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">
        <!-- CONTENT GOES HERE -->
        <div>
            <div class="flex items-center justify-between w-full mb-4">
                <span class="text-3xl font-semibold tracking-tight leading-8">
                    {{
                        "SHARED_CONN_MODULE.InvitationListComponent.TITLE"
                            | translate
                    }}</span
                >
            </div>

            <div class="content">
                <table class="table table-striped tablefixed">
                    <thead>
                        <tr>
                            <th>
                                {{
                                    "SHARED_CONN_MODULE.InvitationListComponent.TABLE_HEADERS.SHARED_WITH"
                                        | translate
                                }}
                            </th>
                            <th>
                                {{
                                    "SHARED_CONN_MODULE.InvitationListComponent.TABLE_HEADERS.DATE"
                                        | translate
                                }}
                            </th>
                            <th>
                                {{
                                    "SHARED_CONN_MODULE.InvitationListComponent.TABLE_HEADERS.REQUESTED_BY"
                                        | translate
                                }}
                            </th>
                            <th>
                                {{
                                    "SHARED_CONN_MODULE.InvitationListComponent.TABLE_HEADERS.ACTION_DATE"
                                        | translate
                                }}
                            </th>
                            <th>
                                {{
                                    "SHARED_CONN_MODULE.InvitationListComponent.TABLE_HEADERS.ACTION_BY"
                                        | translate
                                }}
                            </th>
                            <!-- <th>Action By User Email</th> -->
                            <th>
                                {{
                                    "SHARED_CONN_MODULE.InvitationListComponent.TABLE_HEADERS.STATUS"
                                        | translate
                                }}
                            </th>
                            <th>
                                {{
                                    "SHARED_CONN_MODULE.InvitationListComponent.TABLE_HEADERS.ACTION"
                                        | translate
                                }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let connection of connectionInvitationList">
                            <td>
                                <strong>{{ connection.sharedWith }}</strong>
                            </td>
                            <td>
                                {{
                                    connection.requestDate | date: "mediumDate"
                                }}
                            </td>
                            <td>
                                <small>{{ connection.brandName }}</small>
                            </td>
                            <td>
                                {{ connection.actionDate | date: "mediumDate" }}
                            </td>
                            <td>
                                <small>{{
                                    connection.supplierFirstName
                                }}</small>
                            </td>
                            <!-- <td><small>{{connection.supplierUsername}}</small></td> -->
                            <td>
                                <span *ngIf="connection.status == 1">{{
                                    ConnectionStatusEnum[connection.status]
                                }}</span>
                                <span *ngIf="connection.status == 2">{{
                                    ConnectionStatusEnum[connection.status]
                                }}</span>
                                <span *ngIf="connection.status == 3">{{
                                    ConnectionStatusEnum[connection.status]
                                }}</span>
                                <span *ngIf="connection.status == 4">{{
                                    ConnectionStatusEnum[connection.status]
                                }}</span>
                                <span *ngIf="connection.status == 5">{{
                                    ConnectionStatusEnum[connection.status]
                                }}</span>
                            </td>
                            <td>
                                <span *ngIf="connection.status == 1"
                                    ><a
                                        (click)="
                                            openAcceptInvitationActionDialog(
                                                connection
                                            )
                                        "
                                        >{{
                                            "SHARED_CONN_MODULE.InvitationListComponent.BUTTONS.ACCEPT_REJECT"
                                                | translate
                                        }}</a
                                    ></span
                                >
                                <span *ngIf="connection.status == 2"
                                    ><a
                                        (click)="
                                            openDisconnectConnActionDialog(
                                                connection
                                            )
                                        "
                                        >{{
                                            "SHARED_CONN_MODULE.InvitationListComponent.BUTTONS.DISCONNECT"
                                                | translate
                                        }}</a
                                    ></span
                                >
                                <span *ngIf="connection.status == 3">-</span>
                                <span *ngIf="connection.status == 4"
                                    ><a
                                        (click)="
                                            openDisconnectConnActionDialog(
                                                connection
                                            )
                                        "
                                        >{{
                                            "SHARED_CONN_MODULE.InvitationListComponent.BUTTONS.DISCONNECT"
                                                | translate
                                        }}</a
                                    ></span
                                >
                                <span *ngIf="connection.status == 5">-</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
